import Swiper from "swiper"
import { Navigation, Keyboard } from "swiper/modules"
;(function ($) {
  "use strict"

  $(document).ready(function ($) {
    // Create lightbox overlay structure
    const lightbox = $(".swiper-lightbox-overlay")
    const $galleryClose = $(".lightbox-close")
    const swiperWrapper = lightbox.find(".swiper-wrapper")
    let swiperInstance = null // Declare Swiper outside to allow destruction later
    let $lastFocusableElement = null

    function closeLightbox() {
      lightbox.fadeOut(300, function () {
        $(this).css("display", "none")
        swiperInstance.destroy(true, true) // Destroy Swiper and remove event listeners

        if ($lastFocusableElement.length) {
          $lastFocusableElement.focus()
        }
      })
    }

    lightbox.hide()

    // For each gallery on the page
    $(".wp-block-gallery").each(function (galleryIndex) {
      const gallery = $(this)

      gallery.find("a").each(function (imgIndex) {
        const anchor = $(this)

        // Add click event for each image in the gallery
        anchor.on("click", function (e) {
          e.preventDefault()
          swiperWrapper.empty() // Clear the previous lightbox content
          $lastFocusableElement = $(this)

          // Loop through all figures in the gallery and append them to the swiper wrapper
          gallery.find("figure").each(function () {
            const figure = $(this)
            const slide = $('<div class="swiper-slide"></div>')
            const imgClone = figure.find("img").clone()
            const caption = figure.find(".wp-element-caption").text()

            if (caption) {
              imgClone.attr("data-caption", caption)
            }

            slide.append(imgClone)
            swiperWrapper.append(slide)
          })

          // Open the lightbox
          lightbox.fadeIn(300, function () {
            $(this).css("display", "flex")
            $(this).createTabTrap()
          })

          // Destroy existing Swiper instance if it exists
          if (swiperInstance !== null) {
            swiperInstance.destroy(true, true) // Destroy Swiper and remove event listeners
          }

          // Initialize Swiper
          swiperInstance = new Swiper(".swiper-container", {
            modules: [Navigation, Keyboard],
            a11y: true,
            loop: true,
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 48,
            initialSlide: imgIndex, // Open on the clicked image
            mousewheel: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },
            on: {
              slideChange: function () {
                const activeSlide = this.slides[this.activeIndex]
                const caption = $(activeSlide).find("img").attr("data-caption")

                if (caption) {
                  $(".swiper-lightbox-caption").text(caption)
                } else {
                  $(".swiper-lightbox-caption").text("")
                }
              },
            },
          })

          // Set initial caption
          const initialCaption = swiperWrapper
            .find(".swiper-slide")
            .eq(imgIndex)
            .find("img")
            .attr("data-caption")
          if (initialCaption) {
            $(".swiper-lightbox-caption").text(initialCaption)
          } else {
            $(".swiper-lightbox-caption").text("")
          }
        })
      })
    })

    // Close lightbox on close button click
    $galleryClose.on("click", function () {
      closeLightbox()
    })

    $(document).on("keydown", function (event) {
      if (event.key === "Escape" && swiperInstance !== null) {
        closeLightbox()
      }
    })
  })
})(jQuery)
